import { SET_PAGE_TITLE } from "constants/ActionTypes";

export const setPageTitle = (pageTitle) => {
  return {
    type: SET_PAGE_TITLE,
    payload: pageTitle,
  };
};
